import React, { useContext, useEffect, useState } from "react";
import { Cross } from "../../../../constants/icons/index";
import { ButtonV2 } from "../ButtonV2/ButtonV2";
import clsx from "clsx";
import Modal from 'react-modal';
import { useSelector } from "react-redux";
import { getIsDarkMode } from "@/store/slices/webConfig";
import { screenContext } from "context/ScreenContext";
import { getCookie } from "cookies-next";

export type contentStyleInterface = {
  top?: string
  left?: string,
  right?: string,
  bottom?: string,
  position?: string
  transform?: string,
  borderRadius?: string,
  boxShadow?:string
}

export interface ModalV2Props {
  id?:string
  isOpen: boolean;
  onClose?: () => void;
  modalTitle?:  string | React.ReactNode;
  modalSubTitle? : string;
  contentStyle?: contentStyleInterface;
  contentTop?: string;
  position?: string;
  scrollable?: boolean;
  children: React.ReactNode;
  fullHeight?: boolean;
  isFullWidth?: boolean;
  modalActionsSection?: React.ReactNode;
  title?: string;
  size?: string;
  modalWidth?: string;
  modalHeight?: string;
  maxHeight?: string;
  overrideMaxHeight?: boolean;
  additionalHeaderStyle?:boolean;
  closeIconLeftAlignment?: boolean;
  padding?: string;
  setModalBottom?: boolean;
  showBorderRadius?: boolean;
  hideBorderRadius?: boolean;
  hideOverlayPadding?: boolean;
  hideOverlay?: boolean;
  showDivider?: boolean;
  showDividerFooter?: boolean;
  hideCloseIcon?: boolean;
  shouldCloseOnOverlayClick?: boolean;
  modalAria?: {
    labelledby?: string;    
    describedby?: string;
  },
  className?: string;
  classNamechildren?: string;
  hideTitleCloseIcon?: boolean;
  modalActionClass?: string;
  overrideBackgroundColor?: boolean;
  overrideFlexDirection? : boolean;
  buttonActionSection?:React.ReactNode;
  overrideMaxWidth?:boolean;
  disableScrolling?: boolean;
  additionalClassHeader?: string
}

// Needs complete refactor
export function ModalV2({
  id,
  isOpen,
  onClose,
  modalTitle,
  modalSubTitle,
  children,
  contentStyle,
  scrollable = false,
  fullHeight = true,
  modalActionsSection,
  overrideMaxHeight = false,
  buttonActionSection,
  additionalHeaderStyle=false,
  isFullWidth = false,
  title,
  size = "default",
  modalWidth = "",
  modalHeight = "",
  maxHeight = `${overrideMaxHeight ? "calc(100% - 0px)" : "calc(100% - 64px)"}`,
  padding = "default",
  setModalBottom = false,
  showBorderRadius = false,
  hideBorderRadius = false,
  hideOverlayPadding = false,
  hideOverlay = false,
  showDivider = false,
  showDividerFooter = false,
  hideCloseIcon = false,
  shouldCloseOnOverlayClick = true,
  modalAria = {
    labelledby: 'popUpHeading',    
    describedby: 'popUpSubHeading',
  },
  className,
  classNamechildren = "",
  hideTitleCloseIcon = false,
  modalActionClass = "",
  overrideBackgroundColor = false,
  overrideFlexDirection = false,
  closeIconLeftAlignment = false,
  overrideMaxWidth = false,
  disableScrolling = true,
  additionalClassHeader = ""
}: ModalV2Props) {
  
  const { currentDevice } = useContext(screenContext);
  const isDarkMode = useSelector(getIsDarkMode);
  const [isBackgroundInteraction, setIsBackgroundInteraction] = useState(false);

  const defaultModalContentStyle = {
    top: "50%",
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    transform: 'translate(-50%, -50%)',
    position: "relative",
  }
  const contentClassNames = clsx({
    'overflow-y-auto': scrollable,
    'h-full': fullHeight
  });

  const modalMaxWidth: any = {
    sx: "450px",
    sm: "500px",
    md: "600px",
    lg: "800px",
    XL: "900px",
    XXL: "1022px",
    default: "700px",
    full:"100vw"
  };
  const customStyles = {
    content: {top: `${contentStyle?.top || defaultModalContentStyle?.top}`,
      left: `${contentStyle?.left || defaultModalContentStyle?.left}`,
      right: `${contentStyle?.right || defaultModalContentStyle?.right}`,
      bottom: `${contentStyle?.bottom || defaultModalContentStyle?.bottom}`,
      position: `${contentStyle?.position || defaultModalContentStyle?.position}`,
      transform: `${contentStyle?.transform || defaultModalContentStyle?.transform}`,
      padding: `${padding === 'default' ? '0px': `${padding}`}`,
      width: `${currentDevice === 'mobile' ? `${modalWidth !== "" ? modalWidth : '100%'}` : `${modalWidth !== "" ? modalWidth : 'calc(100% - 64px)'}`}`,
      maxWidth: `${currentDevice !== 'mobile' && modalWidth && overrideMaxWidth ? modalWidth : modalMaxWidth[size] || modalMaxWidth.default}`,
      height: modalHeight,
      maxHeight: maxHeight,
      overflow: 'hidden',
      margin: '0',
      border: '0px',
      borderRadius: `${contentStyle?.borderRadius || (showBorderRadius ? `16px 0 ${currentDevice === 'mobile' ? '0px' : '16px'} ${currentDevice === 'mobile' ? '0px' : '16px'}` : `${hideBorderRadius ? '0px' : '4px'}`)}`,
      display: 'flex',
      flexDirection: overrideFlexDirection ? ('row') : ('column'),
      backgroundColor : `${isDarkMode ? "var(--color-gray-800)" : overrideBackgroundColor ? "var(--color-pink-50)" :" var(--color-bg-default)"}`,
      boxShadow: `${contentStyle?.boxShadow ||"rgba(0, 0, 0, 0.2) 0px 11px 15px -7px, rgba(0, 0, 0, 0.14) 0px 24px 38px 3px, rgba(0, 0, 0, 0.12) 0px 9px 46px 8px"}`,
      pointerEvents: 'auto'
    },
    overlay: {
      backgroundColor: `${hideOverlay ? '' : 'var(--color-bg-highlight-overlay)'}`,
      zIndex: 50,
      overflow: 'auto',
      padding: `${setModalBottom === true || hideOverlayPadding === true ? '0px' : '16px'}`,
      pointerEvents: !getCookie("akasaairCookie") ? 'none' : 'auto'
    }
  };

  useEffect(() => {  
    if(isOpen){
      if(!getCookie("akasaairCookie")){
        document.body.style.overflow = "auto"; 
        setIsBackgroundInteraction(true);
      }
      else{
        document.body.style.overflow = "hidden"; 
        setIsBackgroundInteraction(false);
      }
    }
    else
      document.body.style.overflow = "auto"; 
  }, [disableScrolling, isOpen]);
    
  if (!isOpen) return null;

  return (    
    <Modal
      id={id}
      isOpen={isOpen}
      onRequestClose={onClose}
      style={customStyles}
      className={className}
      aria={modalAria}
      shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
      preventScroll={!isBackgroundInteraction}
    >
      {/* Adding Conditional Header Properties of Modal for Mweb */}
      {!hideTitleCloseIcon && <div style={additionalHeaderStyle && currentDevice === "mobile" ? {
        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
        zIndex: 1000,
        marginBottom:  "12px"
      }:{}}
      className={`flex justify-between items-center ${closeIconLeftAlignment ? 'px-0' : 'px-5'} py-2 ${additionalClassHeader}`}>
        <h1 id="popUpHeading" className="font-semibold text-lg text-typography-primary" data-testid="Dialog Title">{modalTitle}</h1>
        <h2 id="popUpSubHeading" className="font-semibold text-md text-typography-primary" data-testid="Dialog Sub Title">{modalSubTitle}</h2>
        <div className={`${closeIconLeftAlignment ? 'px-0' : '-mr-2'}`}>
          {!hideCloseIcon && <ButtonV2 id="closePopUp" blok={{ variant: "icon", isFullWidthOnMobile: false }} onClick={onClose} title="Close" data-testid="Cancel icon">
            <Cross fill="inherit" />
          </ButtonV2>}
        </div>
      </div>}
      {showDivider && <div className="border-b border-gray-300" />}
        <div className={`${classNamechildren} ${contentClassNames}`}>{children}</div>
        {buttonActionSection && (
          <div className={`flex items-center justify-end ml-auto px-4`}>
            {buttonActionSection}
          </div>
        )}
      {showDividerFooter && <div className="border-t border-gray-300" />}
      {modalActionsSection && <div className={`flex items-center p-2 justify-end ${modalActionClass}`}>{modalActionsSection}</div>}       
    </Modal>    
  );
}
